// =============================================================================
// src/features/mapa-ia/index.ts — Barrel da feature "Mapa de IA".
//
// initMapaIa publica o singleton em window.MapaIaRoute (contrato routeSingletonByName
//   da topbar) e resolve a página. Aberta pelo item de overflow "Mapa de IA" da topbar.
// =============================================================================

import type { AppContext } from '../../app/types';
import { MapaIaRoute } from './mapa-ia-route';

export { buildMapaIaPageMarkup } from './mapa-ia-markup';
export { MapaIaRoute } from './mapa-ia-route';

/** Janela com o singleton que a feature publica (contrato da topbar). */
interface MapaIaPublishWindow {
  MapaIaRoute?: typeof MapaIaRoute;
}

/**
 * Inicializa a feature Mapa de IA: publica o singleton e resolve a página.
 *
 * @example
 *   initMapaIa(context);  // depois abre via TopbarNav overflow → MapaIaRoute.open()
 */
export function initMapaIa(_ctx: AppContext): void {
  publishMapaIaGlobals();
  MapaIaRoute.init();
}

/** Publica MapaIaRoute no window (lido por routeSingletonByName da topbar). */
function publishMapaIaGlobals(): void {
  (window as unknown as MapaIaPublishWindow).MapaIaRoute = MapaIaRoute;
}
